import React from 'react';
import PropTypes from 'prop-types';

import Header from '~/components/Header';
import Projects from '~/components/Projects';

import { Wrapper, Content } from './styles';

export default function DefaultLayout({ children }) {
  return (
    <Wrapper>
      <Header />
      <Projects />
      <Content>{children}</Content>
    </Wrapper>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
